import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../../actions/customer';
import { Link } from '../../../components/router/link';

export class CustomerOrderView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {isLoading: true};
	}

	componentDidMount () {
		this.props.actions.fetchOrder().then(function(response){
			this.setState({
				isLoading: false
			});
		}.bind(this));
	}

	render () {
			let styleCentered = {
				'textAlign' : 'center'
			}
			if(this.state.isLoading == false)
				return (
					<div id="details-order">
						<Link pathname="customer/order">
							<button className="ui orange button"><i className="arrow circle left icon"></i> Powrót do zleceń</button>
						</Link>
						<h4 className="ui horizontal divider header">
							<i className="newspaper icon"></i> <div className="title">Szczegóły zlecenia {this.props.model.id}</div>
						</h4>
						<table className="ui definition table">
							<tbody>
								<tr>
									<td className="six wide column">Planowana data dostawy szkła</td>
									<td>{this.props.model.delivery_date}</td>
								</tr>
								<tr>
									<td className="six wide column">Komentarz z Glasstechniki</td>
									<td>{this.props.model.comment}</td>
								</tr>
								<tr>
									<td className="six wide column">Twój komentarz</td>
									<td>{this.props.model.comment_client}</td>
								</tr>
							</tbody>
						</table>
						<div className="wrap-order-products">
							<table className="ui celled table order-products">
								<thead>
									<tr>
										<th>Grubość</th>
										<th>Szerokość (mm)</th>
										<th>Długość (mm)</th>
										<th style={styleCentered}>Znaczek</th>
										<th style={styleCentered}>Laminacja</th>
										<th>Ilość</th>
										<th style={styleCentered}>Uszkodzenia</th>
										<th>m<sup>2</sup></th>
									</tr>
								</thead>
								<tbody>
									{
										this.props.model.products.map(function(result, index) {
											return (
												<tr key={index}>
													<td>
														{result.name}
													</td>
													<td>
														{result.width}
													</td>
													<td>
														{result.length}
													</td>
													<td className="norm">
														{result.norm ? <i className="chevron circle down icon green"></i> : <i className="remove circle icon red"></i>}
													</td>
													<td className="lamination">
														{result.count_lamination > 0 ? result.count_lamination+' folie'  : <i className="remove circle icon red"></i>}
													</td>
													<td>
														{result.quantity}
													</td>
													<td className="directional">
														{result.damaged ? <i className="warning circle icon red"></i> : <i className="check circle icon green"></i>}
													</td>
													<td>
														{result.m2}
													</td>
												</tr>
											);
										}.bind(this))
									}
								</tbody>
							</table>
						</div>
						{
							this.props.model.discount_code ?
								<div className="ui tag labels">
									<a className="ui red label">
										Zlecenie z kodem rabatowym: &nbsp;&nbsp;
										<span className="ui green button">{this.props.model.discount_code}</span>
									</a>
								</div>
							:
							''
						}
					</div>
				);
			else
				return(<div className="loading-form"></div>);
	}
}

const mapStateToProps = (state) => ({
	model: state.order.model
});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrderView);



/** WEBPACK FOOTER **
 ** ./js/views/customer/order/View.js
 **/